
import { setfav } from './../../../fetch/home'
const types = {
  SETFAV_DATA: 'SETFAV_DATA'
}
const setfavs = {
  state: {
    [types.SETFAV_DATA]: null
  },
  actions: {
    /**
     * 商品的收藏
     */
    [types.SETFAV_DATA]: async ({ commit }, id) => {
      const res = await setfav(id)
      return commit(types.SETFAV_DATA, res)
    }
  },
  mutations: {
    [types.SETFAV_DATA]: (state, res) => {
      state[types.SETFAV_DATA] = res
    }
  },
  getters: {
    getsetfavStatus (state) {
      return state[types.SETFAV_DATA]
    }
  }
}
export default setfavs
